// extracted by mini-css-extract-plugin
export default {"JobDescriptionCard":"JobDescriptionCard_JobDescriptionCard__OtLih","title":"JobDescriptionCard_title__GlYVC","description":"JobDescriptionCard_description__ijYBf"};